module.exports = __webpack_public_path__ + "img/tz6.fe7a424c.jpg";